import React from "react";
import { useTable } from 'react-table';
import TickSvg from './TickSvg';
import CrossSvg from "./CrossSvg";
import classes from './RefundPolicy.module.css';

const RefundPolicy = () => {

    const columns = React.useMemo(
        () => [
            {
                Header: '',
                accessor: 'amountType',
            },
            {
                Header: 'Upto 30 Days',
                accessor: 'daysLeft_XL',
            },
            {
                Header: '30-21 Days',
                accessor: 'daysLeft_L',
            },
            {
                Header: '21-15 Days',
                accessor: 'daysLeft_M',
            },
            {
                Header: '14-0 Days',
                accessor: 'daysLeft_S',
            },
        ],
        []
    );

    const data = [
        {
            amountType: 'Batch Shifting',
            daysLeft_XL: <TickSvg />,
            daysLeft_L: <TickSvg />,
            daysLeft_M: <CrossSvg />,
            daysLeft_S: <CrossSvg />,
        },
        {
            amountType: 'Cancellation Charge',
            daysLeft_XL: 'Free Cancellation',
            daysLeft_L: '25% Deducted',
            daysLeft_M: '50% Deducted',
            daysLeft_S: '100% Deducted',
        },
        {
            amountType: 'Booking Amount',
            daysLeft_XL: 'Refunded in mode of credit note with lifetime validity',
            daysLeft_L: 'No Refund',
            daysLeft_M: 'No Refund',
            daysLeft_S: 'No Refund',
        },
        {
            amountType: 'Remaining Amount',
            daysLeft_XL: 'Full Refund',
            daysLeft_L: 'Partial Refund',
            daysLeft_M: 'Partial Refund',
            daysLeft_S: 'No Refund',
        },
    ];

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns, data });

    return (
        <>
            <div>
                {/* <h1 style={{width:"100%",fontSize:"5vw",textAlign:"center",color:"rgb(230, 84, 57)",marginBottom:"1vw",marginTop:"1vw"}}>Cancellation Policy</h1> */}
                <table {...getTableProps()} style={{width: "100%",height:"20vw"}}>
                    <thead style={{width:"20%",height:"7vw",fontSize:"1.5vw"}}>
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map(column => (
                                    <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {rows.map(row => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps()}>
                                    {row.cells.map((cell,colIndex) => {
                                        return <td {...cell.getCellProps()} style={{width:"20%",height:"7vw",lineHeight:"1.6",textAlign:"center",fontSize:"1.5vw",fontWeight:`${cell.column.id=='amountType'?"bold":"600"}`,padding:`${cell.column.id=='amountType'?"0% 2%":""}`,boxSizing:"border-box"}}>
                                            {colIndex === 0 ? <strong style={{fontSize:"1.7vw"}}>{cell.render('Cell')}</strong> : cell.render('Cell')}
                                        </td>;
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            {/* <img className={classes['refund-img']} src="https://static.wixstatic.com/media/da937f_e9d614329cad4b3789a4db22fe163aa7~mv2.webp" alt="" /> */}
        </>
    )
};

export default RefundPolicy;